import Calculator from "./components/Calculator";

function App() {
  return (
    <div className="min-vh-100 min-vw-100 bg-primary">
      <Calculator />
    </div>
  );
}

export default App;
